module.exports = __webpack_public_path__ + "img/Return.10ae9065.svg";